import config from "../../../configs/config";

const initialState = {
  title: '',
  consent1: '',
  consent2: '',
  title_en: '',
  title_es: '',
  consent1_en: '',
  consent1_es: '',
  consent2_en: '',
  consent2_es: '',
  language: config.language || 'en'  // Track the current language
}

const mainSettings = (state = initialState, action) => {
  switch (action.type) {
    case "SET_MAIN_SETTING": {
      return { ...state, ...action.data, language: config.language || 'en' }
    }
    case "UPDATE_LANGUAGE": {
      return { ...state, language: action.language }
    }
    default: {
      return state
    }
  }
}

export default mainSettings